/**
 * Authentication storage utilities
 * Handles clearing local storage when invalid tokens are detected
 */

/**
 * Clear all authentication-related data from localStorage
 * This is called when:
 * - An invalid token error is detected (401/403)
 * - Token expiration is detected
 * - User manually logs out
 */
export const clearAuthStorage = () => {
  try {
    // Clear Redux persist storage
    const persistedStateKeys = Object.keys(localStorage).filter(key =>
      key.startsWith('persist:')
    );
    
    persistedStateKeys.forEach(key => {
      localStorage.removeItem(key);
    });

    // Clear any other auth-related localStorage items
    localStorage.removeItem('user');
    localStorage.removeItem('token');
    localStorage.removeItem('jwt_token');
    localStorage.removeItem('auth');
  } catch (error) {
    console.error('Error clearing authentication storage:', error);
  }
};

/**
 * Get all localStorage keys (for debugging purposes)
 */
export const getStorageKeys = (): string[] => {
  const keys: string[] = [];
  for (let i = 0; i < localStorage.length; i++) {
    const key = localStorage.key(i);
    if (key) keys.push(key);
  }
  return keys;
};

/**
 * Check if localStorage contains any auth-related data
 */
export const hasAuthData = (): boolean => {
  return (
    localStorage.getItem('persist:culineerAuth') !== null ||
    localStorage.getItem('user') !== null ||
    localStorage.getItem('token') !== null ||
    localStorage.getItem('jwt_token') !== null
  );
};
